var map = {
	"./angelisland.ogg": 12,
	"./bg.png": 49,
	"./grass.png": 13,
	"./k-dead.png": 50,
	"./k-fly.png": 14,
	"./k-lose.wav": 15,
	"./k-start.wav": 16,
	"./logo.png": 17,
	"./pipeBody.png": 5,
	"./pipeHead.png": 6,
	"./ring.png": 18,
	"./ring.wav": 19
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 11;


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*$
// module id = 11
// module chunks = 0